module.exports = __webpack_public_path__ + "pk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/pk.svg
// module id = 757
// module chunks = 0